import Layout from "@/layout"
export default [
  {
    path: "/link",
    component: Layout,
    redirect: "/link/vue",
    meta: {
      title: "官网列表",
      icon: "system-manage"
    },
    children: [
      {
        path: "/link/vue",
        name: "vue",
        meta: {
          title: "vue官方文档", //meta里面也要有title 用于面包屑上使用
          iframeSrc: "https://cn.vuejs.org/",
          cache: "0"
        }
      },
      {
        path: "/link/egg",
        name: "egg",
        meta: {
          title: "egg官网", //meta里面也要有title 用于面包屑上使用
          iframeSrc: "https://www.eggjs.org/zh-CN",
          cache: "1"
        }
      },
      {
        path: "https://www.taobao.com",
        name: "taobao",
        meta: {
          title: "淘宝跳转外部窗口" //meta里面也要有title 用于面包屑上使用
        }
      }
    ]
  },
  {
    path: "/link2",
    component: Layout,
    meta: {
      title: "官网列表",
      icon: "system-manage"
    },
    children: [
      {
        path: "https://www.tmall.com/",
        name: "tmall",
        meta: {
          title: "天猫跳转外部窗口" //meta里面也要有title 用于面包屑上使用
        }
      }
    ]
  }
]